import {useRef} from 'react';
import {Link, useParams} from 'react-router';

import {createDataTableConfig} from '@/lib/helpers/config';

import {DataTable, DataTableRefT} from '@/components/dataTable';

/**
 * Market Detail Distributors Component
 */
function PositionDetailProducts() {
  const {id: positionId} = useParams();

  // State

  // Refs
  const dataTableRef = useRef<DataTableRefT>(null);

  // Data Table Config
  const dataTableConfig = createDataTableConfig({
    enabled: !!positionId,
    table: 'Item',
    title: 'Products Summary',
    columns: [
      '*',
      [
        'Product',
        [
          'product_name',
          'product_id',
          'product_category',
          'product_subcategory',
          'product_ancestor_category',
          'product_strain',
          ['Brand', ['brand_name', 'brand_id']],
        ],
      ],
    ],
    filters: [{column: 'fk_position_id', operator: 'eq', value: positionId}],
    hideAdd: true,
    hideLimitIcon: true,
    hideLimit: true,
    hideSort: true,
    hideTitle: true,
    // addButtonLabel: 'Add Product To Position',
    noResultsMessage: 'No products in position',
    preventScrolling: true,
    columnsDisplay: [
      {header: 'Product ID', field: 'Product.product_id'},
      {
        header: 'Status',
        field: 'item_inventory_type',
        render: row => {
          let status = 'Pending';
          let color = 'warning';

          if (row.fk_retailer_order_id) {
            status = 'Retailer';
            color = 'success';
          } else if (row.fk_distributor_order_id) {
            status = 'Distributor';
            color = 'info';
          }

          return <span className={`badge bg-${color} text-white`}>{status}</span>;
        },
      },
      {header: 'WM ID', field: 'Product.fk_weedmap_product_id'},
      {header: 'Brand', field: 'Product.Brand.brand_name'},
      {header: 'Name', field: 'Product.product_name'},
      {
        header: 'Tags',
        field: 'Product.product_tags',
        render: row => (
          <div className="flex flex-wrap gap-2">
            {Array.isArray(row.Product.product_tags)
              ? row.Product.product_tags.join(', ')
              : String(row.Product.product_tags || '')}
          </div>
        ),
      },
      {header: 'Category', field: 'Product.product_category'},
      {header: 'Subcategory', field: 'Product.product_subcategory'},
      {header: 'Ancestor Category', field: 'Product.product_ancestor_category'},
      {header: 'Strain', field: 'Product.product_strain'},

      {
        header: 'Name',
        field: 'Product.product_name',
        render: row => (
          <Link
            className="text-primary hover:text-primary dark:text-primary"
            to={`/products/${row.Product.product_id}`}
          >
            {row.Product.product_name}
          </Link>
        ),
      },
    ],
  });

  // Stats
  // const statsRow: statsRowT = renderDistributorTableStats(stats?.total, stats?.active, stats?.inactive);

  return (
    <>
      {/* <StatsRowComponent stats={statsRow} /> */}
      <DataTable
        ref={dataTableRef}
        {...dataTableConfig}
        customFilterButtons={[
          {
            label: 'Location',
            onChange: () => {},
            type: 'dropdown',
            options: [
              {label: 'Retail', value: 'retail'},
              {label: 'Distributor', value: 'distributor'},
              {label: 'Pending', value: 'pending'},
            ],
            color: 'primary',
          },
        ]}
      />
    </>
  );
}

export default PositionDetailProducts;
